export { default as SerpStockAdjustmentSlot } from './SerpStockAdjustmentSlot';
